export const iconFontAwesomeArrowsArrowDownLong = (
	<i className="fa-solid fa-arrow-down-long"></i>
);
